// Google Analytics 4 (gtag.js) — env-driven so the Measurement ID is never hardcoded.
// Set REACT_APP_GA_MEASUREMENT_ID (e.g. "G-XXXXXXXXXX") in frontend/.env to enable.
// With no ID set, every function below is a safe no-op (analytics simply stays off).

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let initialized = false;

export function initGA() {
  if (!GA_ID || initialized || typeof window === "undefined") return;
  initialized = true;
  if (window.gtag) return; // tag already installed statically in index.html

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // Disable automatic page_view; we send them manually on every SPA route change.
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// Optional helper to log custom conversions/interactions later (e.g. quiz_completed).
export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}

// --- Conversion events (GA4 recommended names, importable into Google Ads) ---
const PLAN_VALUES = { monthly: 555, yearly: 3333 };

export function trackSignUp(method) {
  trackEvent("sign_up", { method });
}

export function trackLead() {
  trackEvent("generate_lead", { currency: "INR", value: 0 });
}

export function trackBeginCheckout(plan) {
  trackEvent("begin_checkout", {
    currency: "INR",
    value: PLAN_VALUES[plan] || 0,
    items: [{ item_name: `AI Pathshaalaa ${plan} plan` }],
  });
}

export function trackPurchase(plan, transactionId) {
  trackEvent("purchase", {
    transaction_id: transactionId,
    currency: "INR",
    value: PLAN_VALUES[plan] || 0,
    items: [{ item_name: `AI Pathshaalaa ${plan} plan` }],
  });
}
